module.exports = "mutation UpdateIssueTag($data:IssueTagInput!){updateIssueTag(data:$data){success}}"